<div class="parent_map_container position_relative">

  <div #mapDiv [id]="configs.id" class="map"
       [ngClass]="{disable_pointer: showCity,extra_map:configs.type == mapConfigsType.EXTRA ,mobile_map: configs.type == mapConfigsType.MOBILE }"
    ></div>

  <div class="address_hint text_center"
       *ngIf="configs.type == mapConfigsType.EXTRA || configs.type == mapConfigsType.MOBILE">
    <div class="radius_error br_20 text_normal_sub bold mb_16" *ngIf="radiusError">
      {{'order_creation.address_out_of_radius' | translate}}
    </div>
    <div class="address_label" *ngIf="fullAddressObject?.fullAddress">
      {{showCity? fullAddressObject?.cityName : fullAddressObject?.fullAddress}}
      <div class="seller_price font_15" *ngIf="calledFrom === 'ORDER'">
        <span *ngIf="delivery !== null, else empty">
          {{ 'filter_by.delivery' | translate }} {{delivery?.deliveryPrice}}₽
        </span>
        <ng-template #empty>
          {{'empty_state.incorrect_address' | translate}}
        </ng-template>
      </div>
      <img style="position: absolute;
       left: 50%;
    transform: translate(-50%, 0);
    bottom: -6px;
"  src="assets/images/icons/arrow_white.svg">
    </div>
  </div>
  <div class="placemark"></div>
</div>
